'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherInbox } from '@subframe/core';
import { Button, Dialog } from '@/shared/components/ui';
import { ROTA_PAINEL_NOTIFICADO } from '../constants';
interface AvisoNotificadoModalProps {
  aberto: boolean;
  onFechar: () => void;
}
export const AvisoNotificadoModal = t0 => {
  const $ = _c(12);
  const {
    aberto,
    onFechar
  } = t0;
  let t1;
  if ($[0] !== onFechar) {
    t1 = proximo => !proximo && onFechar();
    $[0] = onFechar;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-warning-100 flex h-12 w-12 items-center justify-center rounded-[12px]"><FeatherInbox className="text-warning-800" /></div>;
    t3 = <h2 className="text-heading-dark text-xl font-semibold">Você recebeu uma notificação?</h2>;
    t4 = <p className="text-label-muted text-sm leading-relaxed">Então você não precisa criar conta aqui. Use o link que chegou no seu e-mail ou WhatsApp para abrir o painel do notificado — lá você lê a notificação, responde e negocia sem custo.</p>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Button size="medium" onClick={_temp}>Abrir painel do notificado</Button>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onFechar) {
    t6 = <Dialog.Content className="w-[calc(100%-2rem)] max-w-[460px] gap-4 rounded-[16px] px-7 py-7">{t2}{t3}{t4}<div className="flex flex-wrap gap-2.5">{t5}<Button variant="neutral-secondary" size="medium" onClick={onFechar}>Não, quero criar conta</Button></div></Dialog.Content>;
    $[6] = onFechar;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== aberto || $[9] !== t1 || $[10] !== t6) {
    t7 = <Dialog open={aberto} onOpenChange={t1}>{t6}</Dialog>;
    $[8] = aberto;
    $[9] = t1;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
function _temp() {
  return window.location.assign(ROTA_PAINEL_NOTIFICADO);
}